'use client'

import React from 'react'
import Image from 'next/image'
import { Box, Flex, Stack, Title } from '@mantine/core'
import { motion } from 'framer-motion'
import { useBreakpoint } from '@/hooks/useBreakpoints'
import { staggerContainer, textFadeInVariantsNoTransition } from '@/lib/animations'
// import { ClinicianEndlessCarousel } from '@/components/Refresh/ClinitianWidget/ClinicianEndlessCarousel'
// import { CLINICIAN_TEAM_CAROUSEL_IMAGES } from '@/lib/hardcoded-data/ClinitianWidget/clinicianTeamCarouselImages'
import { parseHtml } from '@/lib/parseHtml'
import type { SkuComponentConfigMap } from '@/types/enums/sku-component-types'

const MIN_HEIGHT_DESKTOP = 400
const DEFAULT_IMAGE_ALT = 'Clinician support'

export function SkuClinicianWidget({ config }: { config: SkuComponentConfigMap['skuClinicianWidget'] }) {
    const { isSm } = useBreakpoint()
    const { title, bodyHtml, imageSrc, imageAlt = DEFAULT_IMAGE_ALT } = config

    return (
        <Box
            id="skuClinicianWidget"
            component={motion.div}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: '-100px 0px' }}
            variants={staggerContainer}
            p={{ base: 24, sm: 48 }}
            maw={1440}
            mx="auto"
            w="100%"
            style={{
                minWidth: 0,
            }}
        >
            <Flex direction={isSm ? 'column' : 'row'} gap={48} align={isSm ? 'stretch' : 'flex-start'} style={{ minWidth: 0 }}>
                <Box
                    component={motion.div}
                    variants={textFadeInVariantsNoTransition}
                    style={{
                        flex: isSm ? 'none' : 1,
                        width: isSm ? '100%' : undefined,
                        minWidth: 0,
                        minHeight: isSm ? 330 : MIN_HEIGHT_DESKTOP,
                        maxHeight: isSm ? undefined : 500,
                        height: isSm ? 'auto' : undefined,
                        position: 'relative',
                        borderRadius: 16,
                        overflow: 'hidden',
                    }}
                >
                    <Image
                        src={imageSrc}
                        alt={imageAlt}
                        fill
                        style={{ objectFit: 'cover' }}
                        sizes={isSm ? '100vw' : '(max-width: 1440px) 50vw, 720px'}
                    />
                </Box>

                <Flex
                    flex={1}
                    direction="column"
                    justify={isSm ? undefined : 'center'}
                    gap={24}
                    style={{
                        minWidth: 0,
                    }}
                >
                    <Box component={motion.div} variants={textFadeInVariantsNoTransition}>
                        <Stack gap={16} mt={isSm ? -24 : 0}>
                            <Title
                                order={2}
                                m={0}
                                c="var(--gm-fg-primary-black)"
                                fz={isSm ? 44 : 56}
                                fw={500}
                                lh={1}
                                style={{ letterSpacing: isSm ? '-1.6px' : '-2.24px' }}
                            >
                                {title}
                            </Title>
                            <Box c="var(--gm-fg-tertiery)" fz={isSm ? 18 : 20} fw={500} lh={1.3}>
                                {parseHtml(bodyHtml)}
                            </Box>
                        </Stack>
                    </Box>

                    {/* <Box
                        component={motion.div}
                        variants={textFadeInVariantsNoTransition}
                        pt={8}
                        w="100%"
                    >
                        <ClinicianEndlessCarousel
                            images={CLINICIAN_TEAM_CAROUSEL_IMAGES}
                            gap={16}
                            startX={0}
                            endGap={0}
                            size="compact"
                        />
                    </Box> */}
                </Flex>
            </Flex>
        </Box>
    )
}
